// Frontend validation functions
export const validateVIN = (vin: string): boolean => {
    // VIN should be exactly 17 characters, alphanumeric (excluding I, O, Q)
    const vinRegex = /^[A-HJ-NPR-Z0-9]{17}$/;
    return vinRegex.test(vin.toUpperCase());
};

export const validateVRM = (vrm: string): boolean => {
    // UK registration number formats
    const ukRegPatterns = [
        /^[A-Z]{2}[0-9]{2}[A-Z]{3}$/, // Current format: AB12 CDE
        /^[A-Z][0-9]{1,3}[A-Z]{3}$/, // Prefix format: A123 BCD
        /^[A-Z]{3}[0-9]{1,3}[A-Z]$/, // Suffix format: ABC 123D
        /^[0-9]{1,4}[A-Z]{1,3}$/, // Dateless format: 1234 AB
        /^[A-Z]{1,3}[0-9]{1,4}$/, // Dateless and Northern Ireland: A 1, ABC 1234
    ];

    const cleanVrm = vrm.replace(/\s/g, '').toUpperCase();
    return ukRegPatterns.some((pattern) => pattern.test(cleanVrm));
};

export const validateVinVrm = (
    input: string
): { isValid: boolean; type: 'vin' | 'vrm' | null; error?: string } => {
    const cleanInput = input.trim().replace(/\s/g, '');

    if (!cleanInput) {
        return { isValid: false, type: null, error: 'Please enter a VIN or registration number' };
    }

    // Check if it looks like a VIN (17 characters)
    if (cleanInput.length === 17) {
        if (validateVIN(cleanInput)) {
            return { isValid: true, type: 'vin' };
        } else {
            return {
                isValid: false,
                type: null,
                error: 'Invalid VIN format. VIN must be 17 characters (A-Z, 0-9, excluding I, O, Q)',
            };
        }
    }

    // Otherwise check if it's a valid VRM
    if (validateVRM(cleanInput)) {
        return { isValid: true, type: 'vrm' };
    }

    return {
        isValid: false,
        type: null,
        error: 'Invalid format. Please enter a valid VIN (17 characters) or UK registration number',
    };
};
